import { httpClient, type Cursor } from '#shared'
import type { GetAlertsResponse } from '../model/get-alerts-response'

interface GetAlertsOptions {
  count?: number
  after?: Cursor
}

export async function getAlerts({ count = 20, after }: GetAlertsOptions = {}): Promise<GetAlertsResponse> {
  const searchParams = new URLSearchParams([['count', count.toString()]])

  if (after) {
    searchParams.set('after', after.toString())
  }

  const response = await httpClient.get<GetAlertsResponse>('alerts?' + searchParams.toString(), { requireAuth: true })
  const responseBody = await response.json()

  return responseBody
}
